// Switching the time window while a load is still in flight leaves two requests
// racing, and the slower one can land last. Each load takes a ticket; only the
// newest ticket may write state, so an old window's numbers never overwrite the
// window the reader is looking at.
export function createLatestOnly(): { next(): number; isLatest(ticket: number): boolean } {
  let latest = 0
  return {
    next: () => ++latest,
    isLatest: (ticket) => ticket === latest,
  }
}
